module.exports = __webpack_public_path__ + "images/icons/icon-payment-diners_club-6ff1b0c3.svg";